import {KnownError} from '@toolify/server/src/middleware/ApiResponseMiddleware/types/KnownError'
import type {ComposerTranslation} from 'vue-i18n'
import {IMessageAction} from '@toolify/client/src/modules/notifications/types/IMessageAction'
import {MessageActionKindType} from '@toolify/client/src/modules/notifications/enum/MessageActionKindType'

interface IWorkspaceBillingBlockedMessageMeta {
  messageKey: string
  linkLabelKey: string
  getHref: (workspaceName: string) => string
}

export interface IWorkspaceBillingBlockedMessage {
  text: string
  // null when no workspace is loaded, so there is nowhere to link to
  action: IMessageAction | null
}

export function getWorkspaceUpgradeHref(workspaceName: string): string {
  return `/@${workspaceName}/upgrade`
}

export function getWorkspacePaymentMethodsHref(workspaceName: string): string {
  return `/@${workspaceName}/settings/billing/payment-methods`
}

const messageMetaByErrorName: Partial<Record<KnownError, IWorkspaceBillingBlockedMessageMeta>> = {
  [KnownError.WORKSPACE_SUBSCRIPTION_REQUIRED]: {
    messageKey: 'errors.workspaceSubscriptionRequired',
    linkLabelKey: 'workspaceUpgrade.upgradePlan',
    getHref: getWorkspaceUpgradeHref,
  },
  [KnownError.WORKSPACE_SUSPENDED]: {
    messageKey: 'errors.workspaceSuspended',
    linkLabelKey: 'billing.suspendedPaywall.changePaymentMethodCta',
    getHref: getWorkspacePaymentMethodsHref,
  },
}

// In-app billing pages open through the router, like any other link action with `to`
export function getBillingLinkAction(href: string | null, label: string): IMessageAction | null {
  if (!href) {
    return null
  }
  return {
    label,
    kind: MessageActionKindType.Link,
    to: href,
  }
}

export function getWorkspaceBillingBlockedMessage(
  errorName: KnownError,
  workspaceName: string | null | undefined,
  t: ComposerTranslation,
): IWorkspaceBillingBlockedMessage | null {
  const meta = messageMetaByErrorName[errorName]
  if (!meta) {
    return null
  }
  return {
    text: t(meta.messageKey),
    action: getBillingLinkAction(workspaceName ? meta.getHref(workspaceName) : null, t(meta.linkLabelKey)),
  }
}
